import { render } from "./reset-password-temporary.vue?vue&type=template&id=9a2a4846"
import script from "./reset-password-temporary.vue?vue&type=script&lang=js"
export * from "./reset-password-temporary.vue?vue&type=script&lang=js"

import "./reset-password-temporary.vue?vue&type=style&index=0&id=9a2a4846&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__